import React, { lazy } from 'react';
export function TreeSection() {
  return <section className="w-full py-20 md:py-28 px-6 bg-beige" data-id="element-205">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-16" data-id="element-206">
        <div className="flex-1 w-full flex justify-center md:justify-start" data-id="element-207">
          <img src="https://cdn.magicpatterns.com/uploads/pHEZdS5KgLwurDwQZTwHu5/ChatGPT_Image_20_mar_2026,_07_57_36_p.m..png" alt="Árbol con raíces brillando" loading="lazy" className="w-full max-w-lg rounded-2xl shadow-2xl shadow-dark/20 object-cover" data-id="element-208" />
        </div>
        <div className="flex-1 text-center md:text-left" data-id="element-209">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-dark leading-tight" data-id="element-210">
            El dolor que no se sana… <br className="hidden md:block" data-id="element-211" />
            <span className="text-terracotta italic" data-id="element-212">se hereda.</span>
          </h2>
        </div>
      </div>
    </section>;
}